var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServices3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 9,
    fill: "#25BCBD",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8952 7.55808C15.6044 7.55808 14.5581 8.60445 14.5581 9.8952V33.2664C14.5581 34.5572 15.6044 35.6036 16.8952 35.6036H27.8195C29.1102 35.6036 30.1566 34.5572 30.1566 33.2664V9.8952C30.1566 8.60445 29.1102 7.55808 27.8195 7.55808H27.8018C27.3715 7.55808 27.0227 7.90687 27.0227 8.33712C27.0227 9.62788 25.9764 10.6742 24.6856 10.6742H20.0114C18.7206 10.6742 17.6742 9.62788 17.6742 8.33712C17.6742 7.90687 17.3255 7.55808 16.8952 7.55808ZM19.0993 7.55808C19.1855 7.80175 19.2323 8.06396 19.2323 8.33712C19.2323 8.76738 19.5811 9.11616 20.0114 9.11616H24.6856C25.1159 9.11616 25.4647 8.76738 25.4647 8.33712C25.4647 8.06396 25.5115 7.80175 25.5976 7.55808H19.0993ZM13 9.8952C13 7.74394 14.7439 6 16.8952 6H27.8195C29.9707 6 31.7147 7.74394 31.7147 9.8952V33.2664C31.7147 35.4177 29.9707 37.1616 27.8195 37.1616H16.8952C14.7439 37.1616 13 35.4177 13 33.2664V9.8952Z",
    fill: "#25BCBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices3);
export default __webpack_public_path__ + "static/media/Services3.dcd1a120a293cac5157af914d62d191d.svg";
export { ForwardRef as ReactComponent };